const Icons = ({icon, style, size, className}) => {
  const sizeClass = size ? `icon--${size}` : "";
  const customClass = className ? className : "";

  switch (icon) {
    case "add-to-cart":
      return (
        <svg
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5.472a.5.5 0 0 1 .5.5v3.5h3.5a.5.5 0 0 1 0 1H13v3.5a.5.5 0 0 1-1 0v-3.5H8.5a.5.5 0 0 1 0-1H12v-3.5a.5.5 0 0 1 .5-.5Z"
            fill="currentcolor"
          />
          <path
            d="M8.278 18.807c-.75 0-1.36.61-1.36 1.36 0 .75.61 1.36 1.36 1.36.75 0 1.36-.61 1.36-1.36 0-.75-.61-1.36-1.36-1.36Zm10 0c-.75 0-1.36.61-1.36 1.36 0 .75.61 1.36 1.36 1.36.75 0 1.36-.61 1.36-1.36 0-.75-.61-1.36-1.36-1.36Zm3.26-12.71a.674.674 0 0 0-.53-.25h-2.18v1.36h1.36l-1.3 6.81c-.05.26-.19.49-.4.66a1.1 1.1 0 0 1-.73.25h-8.86c-.27 0-.53-.08-.73-.25-.21-.17-.35-.4-.4-.66l-1.36-6.81-.27-1.36-.8-4a.677.677 0 0 0-.67-.55h-3.66a.68.68 0 0 0-.68.68c0 .37.31.68.68.68h3.08l.79 3.97s0 .04.01.06l1.52 7.59c.11.58.43 1.09.88 1.46.46.37 1.02.56 1.61.55h8.82c.58 0 1.15-.19 1.61-.55.46-.37.77-.88.88-1.46l1.45-7.63a.66.66 0 0 0-.14-.56l.02.01Z"
            fill="currentcolor"
          />
        </svg>
      )
    case "submit":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.28 2.22a.75.75 0 0 1 .173.791l-7.06 19a.75.75 0 0 1-1.4.016l-3.28-8.24-8.24-3.28a.75.75 0 0 1 .016-1.4l19-7.06a.75.75 0 0 1 .791.173M4.84 9.834l6.73 2.678a.75.75 0 0 1 .42.42l2.677 6.73 5.81-15.639z"
            fill="currentcolor"
          />
        </svg>
      )
    case "search":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5M2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5"
            fill="currentcolor"
            stroke="currentcolor"
          />
        </svg>
      )
    case "caret":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06z"
            fill="currentColor"
            stroke="currentColor"
          />
        </svg>
      )
    case "directions":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={16}
          height={17}
          viewBox="0 0 16 17"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            d="M13.333 7.313a.5.5 0 0 0 0-.707L9.187 2.46a.5.5 0 1 0-.707.707l3.293 3.293H2.5a.5.5 0 0 0-.5.51v7.823a.5.5 0 0 0 1 0V7.46h8.773L8.48 10.752a.5.5 0 0 0 .707.708z"
            fill="currentcolor"
          />
        </svg>
      )
    case "heart":
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.688 4.5C5.483 4.5 3.75 6.207 3.75 8.25c0 3.296 2.062 6.109 4.261 8.16a23.7 23.7 0 0 0 3.983 2.974l.006.004.006-.004a23.7 23.7 0 0 0 3.982-2.975c2.2-2.05 4.262-4.863 4.262-8.159 0-2.043-1.734-3.75-3.937-3.75-1.643 0-3.034.955-3.628 2.288a.75.75 0 0 1-1.37 0C10.72 5.455 9.33 4.5 7.688 4.5M12 20.25l-.352.662-.003-.001-.007-.004-.022-.012-.082-.045q-.108-.06-.301-.173a25.2 25.2 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25 25 0 0 1-4.244 3.17 15 15 0 0 1-.383.219l-.022.012-.007.004h-.002s-.001.001-.353-.661m0 0 .352.662a.75.75 0 0 1-.704 0z"
            fill="currentcolor"
          />
        </svg>
      )
    case "cart":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18 22"
          fill="none"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path fillRule="evenodd" clipRule="evenodd" d="M5.07147 5.50365V8C5.07147 8.27614 5.29533 8.5 5.57147 8.5C5.84761 8.5 6.07147 8.27614 6.07147 8V5.5L11.9286 5.5V8C11.9286 8.27614 12.1525 8.5 12.4286 8.5C12.7048 8.5 12.9286 8.27614 12.9286 8V5.50365C13.1975 5.50769 13.4225 5.51621 13.6187 5.53415C13.9782 5.56704 14.1982 5.62875 14.376 5.72725C14.7419 5.92989 15.0602 6.26215 15.28 6.6933C15.3931 6.91505 15.4722 7.19211 15.5364 7.62417C15.6012 8.06037 15.6462 8.61695 15.7085 9.39202L16.2228 15.792C16.2965 16.7092 16.3493 17.3704 16.3533 17.8908C16.3574 18.4076 16.3119 18.7417 16.2125 19.0115C16.0191 19.5367 15.686 19.9548 15.2819 20.2119C15.0871 20.3359 14.8351 20.4147 14.4101 20.4566C13.9767 20.4994 13.4182 20.5 12.6249 20.5H5.37522C4.58188 20.5 4.02333 20.4994 3.59 20.4566C3.16496 20.4147 2.91296 20.3359 2.71818 20.2119C2.31407 19.9548 1.98099 19.5367 1.78756 19.0115C1.68822 18.7417 1.64273 18.4076 1.64673 17.8908C1.65076 17.3704 1.70359 16.7092 1.77729 15.792L2.29158 9.39201C2.35386 8.61694 2.39885 8.06037 2.46369 7.62417C2.52791 7.19211 2.60696 6.91505 2.72004 6.6933C2.93989 6.26215 3.25815 5.92989 3.62406 5.72725C3.80192 5.62875 4.02187 5.56703 4.38139 5.53415C4.5776 5.51621 4.80258 5.50769 5.07147 5.50365ZM12.9046 4.50318C13.2071 4.50729 13.4737 4.51672 13.7098 4.53831C14.1425 4.57789 14.515 4.6611 14.8605 4.85244C15.4164 5.16033 15.869 5.64702 16.1709 6.23903C16.354 6.59815 16.454 6.99568 16.5255 7.47715C16.5959 7.95063 16.6433 8.54079 16.7038 9.29357L17.2212 15.732C17.2929 16.6249 17.349 17.3222 17.3533 17.8831C17.3577 18.4519 17.3104 18.924 17.1509 19.3571C16.8896 20.0666 16.4259 20.6693 15.8187 21.0556C15.4379 21.2979 15.0105 21.4022 14.5083 21.4518C14.0201 21.5 13.4122 21.5 12.6513 21.5H5.3488C4.58792 21.5 3.97996 21.5 3.49174 21.4518C2.98959 21.4022 2.56215 21.2979 2.18136 21.0556C1.57421 20.6693 1.11046 20.0666 0.849174 19.3571C0.689705 18.924 0.642354 18.4519 0.646761 17.8831C0.651108 17.3222 0.707143 16.6248 0.778892 15.732L1.29627 9.29357C1.35676 8.54079 1.40418 7.95063 1.47456 7.47714C1.54612 6.99568 1.64605 6.59815 1.82918 6.23902C2.13106 5.64702 2.58364 5.16033 3.13959 4.85244C3.4851 4.66109 3.85755 4.57789 4.29031 4.53831C4.5264 4.51672 4.79302 4.50729 5.09552 4.50318C5.30871 2.30968 6.91629 0.5 9.00004 0.5C11.0838 0.5 12.6914 2.30968 12.9046 4.50318ZM11.8995 4.5C11.6928 2.7492 10.4164 1.5 9.00004 1.5C7.58366 1.5 6.30726 2.7492 6.10062 4.5L11.8995 4.5Z" fill="currentcolor"/>
        </svg>
      )
    case "cart-plus":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={15}
          height={15}
          viewBox="0 0 15 15"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.781.667c.184 0 .333.149.333.333v2.333h2.334a.333.333 0 1 1 0 .667H9.114v2.333a.333.333 0 1 1-.666 0V4H6.114a.333.333 0 0 1 0-.667h2.334V1c0-.184.15-.333.333-.333"
            fill="currentcolor"
          />
          <path
            d="M5.967 12.89a.908.908 0 0 0 0 1.813.908.908 0 0 0 0-1.813m6.667 0a.908.908 0 0 0 0 1.813.907.907 0 0 0 0-1.813m2.173-8.473a.45.45 0 0 0-.354-.167H13v.907h.907l-.867 4.54a.75.75 0 0 1-.267.44.73.73 0 0 1-.486.166H6.38a.74.74 0 0 1-.487-.166.75.75 0 0 1-.266-.44l-.907-4.54-.18-.907-.533-2.667a.45.45 0 0 0-.447-.366H1.12a.454.454 0 0 0-.453.453c0 .247.206.453.453.453h2.053L3.7 4.77s0 .027.007.04L4.72 9.87a1.66 1.66 0 0 0 1.66 1.34h5.88a1.74 1.74 0 0 0 1.073-.367c.307-.246.514-.586.587-.973l.967-5.087a.44.44 0 0 0-.094-.373z"
            fill="currentcolor"
          />
        </svg>
      )
    case "placeholder":
      return (
        <svg
          className="placeholder-svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 525.5 525.5"
          style={style}
        >
          <path d="M375.5 345.2q0-.15 0 0 0-.15 0 0c-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7m-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18m4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25m-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4m91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7s.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9zm-5.8-4.5 1.6-12.3h2l1.6 12.3zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9m-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8m7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9m-7.7-66.7v6.8h-9v-6.8zm-8.9 8.3h9v.7h-9zm0 2.1h9v2.3h-9zm26-1.4h-9v-.7h9zm-9 3.7v-2.3h9v2.3zm9-5.9h-9v-6.8h9zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5s.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3s0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7s.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8m221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2" />
          <path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7m5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7s.3.7.7.7m-11.3.1c.4 0 .7-.3.7-.7s-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7" />
          <path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4m5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8q-1.8-.75-3-2.1c-.6-.6-1.5-.6-2.1-.1m-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7s-.9-1.3-1.7-1.1c-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7s-1.5.3-1.7 1.1c-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9" />
          <path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1s-1.3.9-1.1 1.7c.7 3.5 4.1 6.3 7.7 6.3m-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1q-1.2 1.35-3 2.1c-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9" />
        </svg>
      )
    case "arrow":
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06"
            fill="currentcolor"
          />
        </svg>
      )
    case "map-pin":
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3.75a6.75 6.75 0 0 0-6.75 6.75c0 3.296 1.73 5.93 3.537 7.78A18 18 0 0 0 12 20.876a18 18 0 0 0 3.214-2.598c1.805-1.849 3.536-4.483 3.536-7.779A6.75 6.75 0 0 0 12 3.75m0 18-.36.657-.004-.001-.005-.003-.02-.011-.071-.041q-.091-.053-.255-.153c-.217-.133-.524-.33-.89-.589a19.6 19.6 0 0 1-2.682-2.282C5.77 17.337 3.75 14.347 3.75 10.5a8.25 8.25 0 1 1 16.5 0c0 3.846-2.02 6.837-3.963 8.827a19.6 19.6 0 0 1-2.682 2.282 17 17 0 0 1-1.145.742l-.07.04-.02.012-.006.003-.002.001s-.002 0-.362-.657m0 0 .36.658a.75.75 0 0 1-.72 0zm0-13.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 10.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0"
            fill="currentcolor"
             stroke="currentcolor"
          />
        </svg>
      )
    case "close":
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06"
            fill="currentcolor"
            stroke="currentcolor"
          />
        </svg>
      )
    case "checkbox-checked":
      return(
        <svg
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <rect width={20} height={20} rx={5} fill="#002B54" />
          <path
            d="m14 7-5.5 5.5L6 10"
            stroke="#fff"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "checkbox":
      return(
        <svg
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <rect
            x={0.5}
            y={0.5}
            width={19}
            height={19}
            rx={4.5}
            fill="#fff"
            stroke="#002B54"
          />
          <path
            d="m14 7-5.5 5.5L6 10"
            stroke="#fff"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "success":
      return (
        <svg
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM10.2906 6.09313C10.5153 6.25364 10.5674 6.56591 10.4069 6.79062L7.90687 10.2906C7.82144 10.4102 7.68772 10.4862 7.54124 10.4983C7.39476 10.5104 7.25037 10.4575 7.14645 10.3536L5.64645 8.85355C5.45118 8.65829 5.45118 8.34171 5.64645 8.14645C5.84171 7.95118 6.15829 7.95118 6.35355 8.14645L7.4362 9.22909L9.59313 6.20938C9.75364 5.98467 10.0659 5.93263 10.2906 6.09313Z"
            fill="currentcolor"
          />
        </svg>
      )
    case "warning":
      return (
        <svg
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.866 2.502a1 1 0 0 0-1.733 0L2.231 11a1 1 0 0 0 .866 1.5h9.805a1 1 0 0 0 .867-1.5zm-2.599-.5c.77-1.334 2.695-1.334 3.465 0l4.903 8.499c.77 1.333-.193 2.999-1.732 2.999H3.097c-1.54 0-2.502-1.666-1.733-3zM8 5.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m-.5 5A.5.5 0 0 1 8 10h.005a.5.5 0 0 1 .5.5v.005a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5z"
            fill="currentcolor"
          />
        </svg>
      )
    case "error":
      return (
        <svg
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0m4.646-1.854a.5.5 0 0 1 .708 0L8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 0 1 0-.708"
            fill="currentcolor"
          />
        </svg>
      )
    case "cart":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18 22"
          fill="none"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.071 5.504V8a.5.5 0 0 0 1 0V5.5h5.858V8a.5.5 0 0 0 1 0V5.504c.268.004.493.012.69.03.36.033.58.095.757.193.366.203.684.535.904.966.113.222.192.5.256.931.065.436.11.993.173 1.768l.514 6.4c.074.917.126 1.578.13 2.099.004.517-.041.85-.14 1.12-.194.526-.527.944-.931 1.2-.195.125-.447.204-.872.246-.433.042-.992.043-1.785.043h-7.25c-.793 0-1.352 0-1.785-.043-.425-.042-.677-.121-.872-.245-.404-.257-.737-.675-.93-1.2-.1-.27-.145-.604-.141-1.121.004-.52.057-1.182.13-2.099l.515-6.4c.062-.775.107-1.332.172-1.768.064-.432.143-.709.256-.93.22-.432.538-.764.904-.967.178-.098.398-.16.757-.193a9 9 0 0 1 .69-.03m7.834-1q.452.003.805.034c.432.04.805.123 1.15.314a3.27 3.27 0 0 1 1.31 1.387c.184.36.284.757.355 1.238.07.474.118 1.064.179 1.817l.517 6.438c.072.893.128 1.59.132 2.151.005.569-.043 1.041-.202 1.474-.261.71-.725 1.312-1.332 1.699-.381.242-.809.346-1.31.396-.489.048-1.097.048-1.858.048H5.35c-.761 0-1.369 0-1.857-.048-.502-.05-.93-.154-1.31-.396-.608-.387-1.072-.99-1.333-1.699-.16-.433-.207-.905-.202-1.474.004-.56.06-1.258.132-2.151l.517-6.438c.06-.753.108-1.343.179-1.817.071-.481.171-.879.354-1.238a3.27 3.27 0 0 1 1.31-1.387c.346-.19.719-.274 1.151-.314a11 11 0 0 1 .806-.035C5.309 2.31 6.916.5 9 .5s3.691 1.81 3.905 4.003M11.9 4.5c-.207-1.75-1.484-3-2.9-3s-2.693 1.25-2.9 3z"
            fill="currentcolor"
          />
        </svg>
      )
    case "filter":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 15 16"
          fill="none"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.25 5.79a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0m.534.468a1.25 1.25 0 0 1-2.318 0H2.5v-.937h1.966a1.25 1.25 0 0 1 2.318 0H12.5v.937zM8.75 9.54a.625.625 0 1 1 1.25 0 .625.625 0 0 1-1.25 0m-.534-.47a1.25 1.25 0 0 1 2.318 0H12.5v.938h-1.966a1.25 1.25 0 0 1-2.318 0H2.5v-.937z"
            fill="currentcolor"
          />
        </svg>
      )
    case "plus":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 25 25"
          fill="none"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5 3.906c.431 0 .781.35.781.781v7.032h7.031a.781.781 0 0 1 0 1.562h-7.03v7.031a.781.781 0 1 1-1.563 0v-7.03H4.688a.781.781 0 1 1 0-1.563h7.03V4.688c0-.432.35-.782.782-.782"
            fill="currentcolor"
          />
        </svg>
      )
    case "minus":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 25 25"
          fill="none"
          style={style}
          className={`icon ${sizeClass} ${customClass}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.427 12.5c0-.431.35-.781.781-.781h14.584a.781.781 0 1 1 0 1.562H5.208a.78.78 0 0 1-.78-.781"
            fill="currentcolor"
          />
        </svg>
      )
    default:
      return (
        <span>Icon not found</span>
      )
  }
}

export default Icons;
